import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { FaArrowRight } from "react-icons/fa";
import { addToCart } from "../../../redux/actions/CartActions";
import Loader from "../../../components/loader/Loader";
import FormalityHeader from "../../../components/header/FormalityHeader";
import { updatePassportRequest } from "../../../redux/actions/FormalityActions";
import Swal from "sweetalert2";
import "../../styles/flow-form.css";

function PassportID() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authUser);
  const { formalityRequest } = useSelector((state) => state.formalityRequest);
  const cart = useSelector((state) => state.cart);
  const [submitting, setSubmitting] = useState(false);

  // Validation dynamique selon cart.passportType
  const validationSchema = Yup.object().shape({
    motherName: Yup.string().required("Le nom de la mère est requis"),
    nicNumber:
      cart.passportType === "first_time"
        ? Yup.string().required("Le numéro CNI est requis")
        : Yup.string(),
    nicIssueDate:
      cart.passportType === "first_time"
        ? Yup.string().required("La date de délivrance CNI est requise")
        : Yup.string(),
    previousPassportNumber:
      cart.passportType !== "first_time"
        ? Yup.string().required("Le numéro du passeport précédent est requis")
        : Yup.string(),
    previousPassportIssueDate:
      cart.passportType !== "first_time"
        ? Yup.string().required(
            "La date de délivrance du passeport précédent est requise"
          )
        : Yup.string(),
  });

  const handleSubmit = async (values) => {
    setSubmitting(true);

    // Créer une copie propre des valeurs Formik
    const cleanedValues = {};
    Object.keys(values).forEach((key) => {
      if (values[key] && values[key].trim() !== "") {
        cleanedValues[key] = values[key];
      }
    });

    await dispatch(addToCart(cleanedValues));

    // Ici, on fusionne cart et cleanedValues, mais en filtrant encore les "" dans cart si nécessaire
    const cleanedCart = {};
    Object.keys(cart).forEach((key) => {
      if (cart[key] && cart[key].toString().trim() !== "") {
        cleanedCart[key] = cart[key];
      }
    });

    await dispatch(
      updatePassportRequest(
        user.token,
        formalityRequest.reference,
        {
          ...cleanedValues,
          ...cleanedCart,
        },
        handleCallback
      )
    );
  };

  const handleCallback = ({ success, message }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      navigate("/formality-payment");
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  return (
    <div className="legacy-flow">
      <FormalityHeader from={cart.from} />
      <Loader isLoading={submitting} />

      <div className="container mt-3 text-center" style={{ maxWidth: "800px" }}>
        <h4 className="text-center mt-4 mb-4">
          Information sur votre{" "}
          <span style={{ color: "#FF5500" }}>Pièce d'identité</span>
        </h4>
      </div>

      <div className="container mt-4 d-flex justify-content-center">
        <Formik
          initialValues={{
            motherName: "",
            fatherName: "",
            nicNumber: "",
            nicIssueDate: "",
            previousPassportNumber: "",
            previousPassportIssueDate: "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched }) => (
            <Form
              style={{ textAlign: "left", maxWidth: "400px", width: "100%" }}
            >
              <div className="mb-3">
                <label>Nom complet de la mère</label>
                <Field name="motherName" className="form-control" />
                {errors.motherName && touched.motherName && (
                  <div className="text-danger">{errors.motherName}</div>
                )}
              </div>
              <div className="mb-3">
                <label>Prénom complet du père</label>
                <Field name="fatherName" className="form-control" />
                {errors.fatherName && touched.fatherName && (
                  <div className="text-danger">{errors.fatherName}</div>
                )}
              </div>
              {cart.passportType === "first_time" && (
                <>
                  <div className="mb-3">
                    <label>Numéro CNI</label>
                    <Field name="nicNumber" className="form-control" />
                    {errors.nicNumber && touched.nicNumber && (
                      <div className="text-danger">{errors.nicNumber}</div>
                    )}
                  </div>

                  <div className="mb-3">
                    <label>Date de délivrance CNI</label>
                    <Field
                      type="date"
                      max={new Date().toISOString().split("T")[0]}
                      name="nicIssueDate"
                      className="form-control"
                    />
                    {errors.nicIssueDate && touched.nicIssueDate && (
                      <div className="text-danger">{errors.nicIssueDate}</div>
                    )}
                  </div>
                </>
              )}

              {cart.passportType !== "first_time" && (
                <>
                  <div className="mb-3">
                    <label>Numéro du dernier passeport</label>
                    <Field
                      name="previousPassportNumber"
                      className="form-control"
                    />
                    {errors.previousPassportNumber &&
                      touched.previousPassportNumber && (
                        <div className="text-danger">
                          {errors.previousPassportNumber}
                        </div>
                      )}
                  </div>

                  <div className="mb-3">
                    <label>Date de délivrance du dernier passeport</label>
                    <Field
                      type="date"
                      max={new Date().toISOString().split("T")[0]}
                      name="previousPassportIssueDate"
                      className="form-control"
                    />
                    {errors.previousPassportIssueDate &&
                      touched.previousPassportIssueDate && (
                        <div className="text-danger">
                          {errors.previousPassportIssueDate}
                        </div>
                      )}
                  </div>
                </>
              )}

              <div className="d-flex justify-content-center">
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#051259",
                    borderRadius: "10px",
                    color: "#fff",
                    width: "180px",
                    padding: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  Suivant <FaArrowRight style={{ marginLeft: "8px" }} />
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default PassportID;
